module.exports = __webpack_public_path__ + "595559e0245ff88c8547ffc061f13e08.svg";